import { defineMessages } from 'react-intl';

export const notFoundMessages = defineMessages({
  title: {
    id: 'app.sml.notFound.title',
    defaultMessage: 'Page not found',
  },
  text: {
    id: 'app.sml.notFound.text',
    defaultMessage: 'This address does not go to a page of MUSIC24. The link is old or has a typing error.',
  },
  openHome: {
    id: 'app.sml.notFound.openHome',
    defaultMessage: 'Go to Home',
  },
  signIn: {
    id: 'app.sml.notFound.signIn',
    defaultMessage: 'Sign in',
  },
});
